import { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, browserHistory } from 'react-router'
import {
  getActiveLanguage,
  getTranslate,
  getLanguages,
  setActiveLanguage
} from 'react-localize-redux'
import cx from 'classnames'

import styles from './AuxHeader.module.scss'
import * as Routes from 'constants/Routes'
import { getUser } from 'common/selectors/user'
import { InbiotLogo } from 'icons'
import { ReactComponent as ManageAccountsIcon } from 'icons/manage_accounts.svg'
import { ReactComponent as HelpIcon } from 'icons/help.svg'
import { ReactComponent as ProfileLogo } from 'icons/profile.svg'

import { AppBar, Toolbar, MenuItem, Menu, Fade, Button, Icon, SvgIcon } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'
import { ReactComponent as HomeIcon } from 'icons/HomeIcon.svg'
import LanguageSelector from '../LanguageSelector/LanguageSelector'

const AuxHeader = props => {
  const { activeLanguage, languages, setActiveLanguage } = props
  const lang = activeLanguage.name
  const location = window.location.pathname

  const workspacePages = [Routes.PROJECTS, Routes.DEVICES, Routes.INTEGRATIONS]
  const isWorkspacePage = workspacePages.some(page => location.includes(page))

  const [userAnchorEl, setUserAnchorEl] = useState(null)

  const redirect = route => {
    browserHistory.push(route)
  }

  const handleMenuUserOpen = event => {
    if (userAnchorEl) {
      setUserAnchorEl(null)
    } else {
      setUserAnchorEl(event.currentTarget)
    }
  }

  const handleUserClick = option => {
    switch (option) {
      case 'edit-profile':
        setUserAnchorEl(false)
        redirect(Routes.PROFILE)
        break
      case 'help':
        setUserAnchorEl(null)
        window.open('https://www.inbiotair.com/support', '_blank')
        break
      case 'logout':
        setUserAnchorEl(false)
        redirect(Routes.LOGOUT)
        break
      default:
        break
    }
  }

  const userDropDown = () => {
    const StyledMenu = props => (
      <Menu
        {...props}
        classes={{ paper: styles.menuUserPaper }}
      />
    )

    return (
      <div>
        <Button
          disableRipple
          aria-controls='user-menu'
          aria-haspopup='true'
          onClick={handleMenuUserOpen}
          classes={{ root: { textTransform: 'none' } }}
          className={cx(styles.navItem, styles.buttonLanguages)}
        >
          <ProfileLogo className={styles.navUserItemLogo} />
        </Button>
        <StyledMenu
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          id='user-menu'
          anchorEl={userAnchorEl}
          keepMounted
          open={Boolean(userAnchorEl)}
          onClose={() => setUserAnchorEl(null)}
          TransitionComponent={Fade}
        >
          <MenuItem
            key='edit-profile'
            onClick={() => handleUserClick('edit-profile')}
            className={styles.menuItem}
          >
            <SvgIcon
              className={styles.userOptionsLogo}
              component={ManageAccountsIcon}
              viewBox='0 0 24 24'
            />
            <Typography className={styles.userOptionsText}>{translate('Configuration')}</Typography>
          </MenuItem>

          <MenuItem
            key='help'
            onClick={() => handleUserClick('help')}
            className={styles.menuItem}
          >
            <SvgIcon
              className={styles.userOptionsLogo}
              component={HelpIcon}
              viewBox='0 0 24 24'
              fillOpacity='1'
            />
            <Typography className={styles.userOptionsText}>{translate('help')}</Typography>
          </MenuItem>
          <MenuItem
            key='logout'
            onClick={() => handleUserClick('logout')}
            className={styles.menuItem}
          >
            <ExitToAppOutlinedIcon className={styles.userOptionsLogo} />
            <Typography className={styles.userOptionsText}>{translate('logout')}</Typography>
          </MenuItem>
        </StyledMenu>
      </div>
    )
  }

  const changeSelectedLanguage = lang => {
    setActiveLanguage(lang)
  }

  const { isLoggedIn, translate } = props

  return (
    <AppBar className={isLoggedIn ? styles.componentLoggedIn : styles.componentLoggedOut}>
      <Toolbar className={styles.content}>
        <div className={styles.logoWrapper}>
          <Icon>
            <img
              className={styles.logoImage}
              src={InbiotLogo}
              alt='inBiot Logo'
            />
          </Icon>
        </div>
        {isLoggedIn && !isWorkspacePage && (
          <div className={styles.homePage}>
            <Typography
              onClick={() => redirect(Routes.PROJECTS)}
              className={styles.navItem}
            >
              <HomeIcon className={styles.homeLogoImage} />
            </Typography>
          </div>
        )}
        <div className={styles.auxHeaderContent}>
          {isLoggedIn && <div className={styles.user}>{userDropDown()}</div>}
        </div>
        {!isLoggedIn && (
          <div className={styles.mobileLanguageWrapper}>
            <LanguageSelector
              translate={translate}
              onChange={changeSelectedLanguage}
              selected={lang}
              languages={languages}
              desktopVersion
              position='bottomLeft'
            />
          </div>
        )}
      </Toolbar>
    </AppBar>
  )
}

AuxHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  user: getUser(state),
  activeLanguage: getActiveLanguage(state.localize),
  languages: getLanguages(state.localize),
  translate: getTranslate(state.localize)
})

const mapActionsToProps = {
  setActiveLanguage
}

export default withRouter(connect(mapStateToProps, mapActionsToProps)(AuxHeader))
